var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline text-black mr-1 ml-1"},[_vm._v(" "+_vm._s(_vm.$t('secondsRemainToSendAnotherOtp', { time: _vm.remainingTime }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }